export const recordingLinkTableHeaderList = [
    { headerName: "", width: "5%" },
    { headerName: "RECORDING BY", width: "30%" },
    { headerName: "CREATED ON", width: "20%" },
    { headerName: "RECORDING LINK", width: "40%" },
]

export const rateClassTableHeaderList = [
    { headerName: "RATE CLASS", width: "15%" },
    { headerName: "#", width: "5%" },
    { headerName: "QUESTION TITLE", width: "45%" },
    { headerName: "QUESTION ANSWERS", width: "15%" },
    { headerName: "CREATED ON", width: "20%" },
]

export const lindDeclineTableHeaderList = [
    { headerName: "Description", width: "45%" },
    { headerName: "Code", width: "25%" },
    { headerName: "Decision", width: "30%" },
]

export const declineDetailsTableHeaderList = [
    { headerName: "#", width: "5%" },
    { headerName: "QUESTION TITLE", width: "65%" },
    { headerName: "QUESTION ANSWERS", width: "30%" },
]

export const applicationProgressTableHeaderList = [
    { headerName: "LAST COMPLETED SECTION", width: "15%" },
    { headerName: "#", width: "5%" },
    { headerName: "QUESTION TITLE", width: "45%" },
    { headerName: "QUESTION ANSWERS", width: "25%" },
]

export const ThreePsCodeTableHeaderList = [
    { headerName: "#", width: "5%" },
    { headerName: "CODE", width: "40%" },
    { headerName: "SUB CATEGORY", width: "20%" },
    { headerName: "ORIGINAL DESCRIPTION", width: "35%" },
]